import React from "react";
import AppLayout from "layouts/AppLayout";

const Course = () => {
  return <AppLayout>Course page</AppLayout>;
};

export default Course;
